import { ThemeProvider } from '@emotion/react';
import { Outlet, useLocation } from 'react-router-dom';
import { createTheme, CssBaseline } from '@mui/material';
import { useState } from 'react';

const orangeTheme = {
  typography: {
    fontFamily: 'Spiegel, Segoe UI',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Spiegel';
          src: url('/res/spiegel.ttf') format('truetype');
          font-weight: normal;
          font-style: normal;
        }
      `,
    },
  },
  palette: {
    primary: { main: '#000000'},
    secondary: { main: '#FFFFFF'},
    mariano: { 
      main: '#0A57A3',
      secondary: '#fbca83',
      terciary: '#fbca8366'
    },
    btnStyle: {
      main: '#fbca83',
    }
  },
};

const blueTheme = {
  ...orangeTheme,
  palette: {
    primary: { main: '#0A57A3' },
    secondary: { main: '#000000' },
    mariano: {
      main: '#121212',
      secondary: '#f2f7fc',
      terciary: '#f2f7fc'
    },
    btnStyle: {
      main: '#0A57A3',
      light: '#77ace0',
      contrastText: '#ffffff',
    },
  },
};

function App() {
  const [theme, setTheme] = useState(createTheme(blueTheme));

  // const toggleTheme = () => {
  //   setTheme((prevTheme) => prevTheme.palette.primary.main === '#000000' ? createTheme(blueTheme) : createTheme(orangeTheme));
  // };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Outlet/>
    </ThemeProvider>
  );
}

export default App;
